import { call, put, takeEvery } from "redux-saga/effects";
import {  toast } from 'react-toastify';
import { GET_ADDCOMPLIANCE_FAILED, GET_ADDCOMPLIANCE_REQUESTED, GET_ADDCOMPLIANCE_SUCCESS, GET_ADDONBOARD_COMPLIANCE_FAILED, GET_ADDONBOARD_COMPLIANCE_REQUESTED, GET_ADDONBOARD_COMPLIANCE_SUCCESS, GET_APPROVECOMPLIANCE_FAILED, GET_APPROVECOMPLIANCE_REQUESTED, GET_APPROVECOMPLIANCE_SUCCESS, GET_COMPLIANCE_FAILED, GET_COMPLIANCE_REQUESTED, GET_COMPLIANCE_SUCCESS, GET_CONFIGCOMPLIANCE_FAILED, GET_CONFIGCOMPLIANCE_REQUESTED, GET_CONFIGCOMPLIANCE_SUCCESS, GET_COPMLIANCEVALIDATION, GET_ONBOARD_COMPLIANCE_FAILED, GET_ONBOARD_COMPLIANCE_REQUESTED, GET_ONBOARD_COMPLIANCE_SUCCESS, GET_UPDATECOMPLIANCE_FAILED, GET_UPDATECOMPLIANCE_REQUESTED, GET_UPDATECOMPLIANCE_SUCCESS } from "resources/actionTypes";
import { complianceApi, onBoardComplianceApi, addComplianceApi, addOnBoardComplianceApi, configComplianceApi, approveComplianceApi, updateComplianceApi, getComplianceRegexService } from "services/ComplianceService";
import store from "redux/store";
import { getCompliance, getConfigCompliance, getOnBoardCompliance } from "redux/actions/UserCompliance";

function* fetchCompliance(action) {
  try {
    const payload = action.payload || {}
    const userCompliance = yield call(complianceApi, payload);
    yield put({ type: GET_COMPLIANCE_SUCCESS, userCompliance: userCompliance });
  } catch (e) {
    yield put({ type: GET_COMPLIANCE_FAILED, message: e.message });
    toast.error(e.message || 'Get Compliance Failed')
  }
}

export function* complianceSaga() {
  yield takeEvery(GET_COMPLIANCE_REQUESTED, fetchCompliance);
}

function* fetchApproveCompliance(action) {
  const payload = action.payload || {}
  const userApproveCompliance = yield call(approveComplianceApi, payload.userApproveCompliance);
  if(userApproveCompliance.success){
    yield put({ type: GET_APPROVECOMPLIANCE_SUCCESS, userApproveCompliance: userApproveCompliance });
    toast.success(userApproveCompliance.message);
    store.dispatch(getCompliance(payload.userApproveCompliance));
  }else{
    yield put({ type: GET_APPROVECOMPLIANCE_FAILED, message: userApproveCompliance.message });
      toast.error(userApproveCompliance.message || 'Approve Sub-Vendor failed');
  }
}
export function* approveComplianceSaga() {
  yield takeEvery(GET_APPROVECOMPLIANCE_REQUESTED, fetchApproveCompliance);

}

function* fetchConfigCompliance(action) {
  try {
    const payload = action.payload || {}
    const userConfigCompliance = yield call(configComplianceApi, payload);
    yield put({ type: GET_CONFIGCOMPLIANCE_SUCCESS, userConfigCompliance: userConfigCompliance });
  } catch (e) {
    yield put({ type: GET_CONFIGCOMPLIANCE_FAILED, message: e.message });
    toast.error(e.message || 'Get Config Compliance Failed')
  }
}

export function* configComplianceSaga() {
  yield takeEvery(GET_CONFIGCOMPLIANCE_REQUESTED, fetchConfigCompliance);
}

function* fetchOnBoardCompliance(action) {

  try {
    const payload = action.payload || {}
    const userOnBoardCompliance = yield call(onBoardComplianceApi, payload?.userOnBoardCompliance);
    yield put({ type: GET_ONBOARD_COMPLIANCE_SUCCESS, userOnBoardCompliance: userOnBoardCompliance });
  } catch (e) {
    yield put({ type: GET_ONBOARD_COMPLIANCE_FAILED, message: e.message });
    toast.error(e.message || 'Get OnBoardCompliance Failed')
  }
}

export function* onBoardComplianceSaga() {
  yield takeEvery(GET_ONBOARD_COMPLIANCE_REQUESTED, fetchOnBoardCompliance);
}

function* fetchAddCompliance(action) {
  const payload = action.payload || {}
  const userAddCompliance = yield call(addComplianceApi, payload.userAddCompliance);
  if(userAddCompliance.sucess){
    yield put({ type: GET_ADDCOMPLIANCE_SUCCESS, userAddCompliance: userAddCompliance });
    toast.success(userAddCompliance.message);
    store.dispatch(getConfigCompliance({...payload.userAddCompliance, type:payload?.userAddCompliance?.type+'Registration'}));
  }else{
    yield put({ type: GET_ADDCOMPLIANCE_FAILED, message: userAddCompliance.message });
      toast.error(userAddCompliance.message || 'Add Sub-Vendor failed');
  }
}
export function* addComplianceSaga() {
  yield takeEvery(GET_ADDCOMPLIANCE_REQUESTED, fetchAddCompliance);

}

function* fetchUpdateCompliance(action) {
  const payload = action.payload || {}
  const userUpdateCompliance = yield call(updateComplianceApi, payload.userUpdateCompliance);
  if(userUpdateCompliance.success){
    yield put({ type: GET_UPDATECOMPLIANCE_SUCCESS, userUpdateCompliance: userUpdateCompliance });
    toast.success(userUpdateCompliance.message);
    store.dispatch(getConfigCompliance(payload.userUpdateCompliance));
  }else{
    yield put({ type: GET_UPDATECOMPLIANCE_FAILED, message: userUpdateCompliance.message });
      toast.error(userUpdateCompliance.message || 'Update Sub-Vendor failed');
  }
}
export function* updateComplianceSaga() {
  yield takeEvery(GET_UPDATECOMPLIANCE_REQUESTED, fetchUpdateCompliance);

}

function* fetchAddOnBoardCompliance(action) {
  const payload = action.payload || {}
  const userAddOnBoardCompliance = yield call(addOnBoardComplianceApi, payload.userAddOnBoardCompliance);
  if(userAddOnBoardCompliance?.success){
    yield put({ type: GET_ADDONBOARD_COMPLIANCE_SUCCESS, userAddOnBoardCompliance: userAddOnBoardCompliance });
    toast.success(userAddOnBoardCompliance.message);
    if(payload?.userAddOnBoardCompliance?.get('vehicleId')){
    store.dispatch(getOnBoardCompliance({vehicleId:payload?.userAddOnBoardCompliance?.get('vehicleId'), type:'vehicleRegistration'}))}
    if(payload?.userAddOnBoardCompliance?.get('driverId')){
      store.dispatch(getOnBoardCompliance({driverId:payload?.userAddOnBoardCompliance?.get('driverId'), type:'driverRegistration'}))
    }
    else{
    store.dispatch(getOnBoardCompliance());}
  }else{
    yield put({ type: GET_ADDONBOARD_COMPLIANCE_FAILED, message: userAddOnBoardCompliance.message });
      toast.error(userAddOnBoardCompliance.message|| 'Add Sub-Vendor failed');
  }
}
export function* addOnBoardComplianceSaga() {
  yield takeEvery(GET_ADDONBOARD_COMPLIANCE_REQUESTED, fetchAddOnBoardCompliance);
}

function* complianceValidationRegexWorker(action) {
  const complianceValidation = yield call(getComplianceRegexService);
  if(complianceValidation?.success){
    yield put({ type: GET_COPMLIANCEVALIDATION.GET_COPMLIANCEVALIDATION_SUCCESS, complianceRegexValidationList: complianceValidation });
  }else{
    yield put({ type: GET_COPMLIANCEVALIDATION.GET_COPMLIANCEVALIDATION_FAILED, message: complianceValidation.message });
  }
}
export function* complianceValidationRegexWatcher() {
  yield takeEvery(GET_COPMLIANCEVALIDATION.GET_COPMLIANCEVALIDATION_REQUESTED, complianceValidationRegexWorker);
}
